import { useSearchParams } from 'react-router-dom';
import { GoogleAdsShell } from '@/components/google-ads/GoogleAdsShell';
import GoogleAdsReporting from './GoogleAdsReporting';
import GoogleAdsAudiences from './GoogleAdsAudiences';
import GoogleAdsLeadForms from './GoogleAdsLeadForms';
import { BarChart2, Target, FormInput } from 'lucide-react';

/**
 * The measurement-and-targeting side of Google Ads — what performance looks
 * like, who you're targeting, and where leads come in. One sidebar entry.
 */
export default function GoogleAdsToolsManager() {
  const [params, setParams] = useSearchParams();
  const tabs = [
        { id: 'reporting', label: 'Reporting', icon: <BarChart2 size={14} />, render: () => <GoogleAdsReporting embedded /> },
        { id: 'audiences', label: 'Audiences', icon: <Target size={14} />, render: () => <GoogleAdsAudiences embedded /> },
        { id: 'lead-forms', label: 'Lead forms', icon: <FormInput size={14} />, render: () => <GoogleAdsLeadForms embedded /> },
      ];
  const active = tabs.find((tab) => tab.id === params.get('tab')) ?? tabs[0];
  return <GoogleAdsShell section="Measurement" title="See what makes an impact." description="Understand performance, reach the right people, and turn interest into leads.">
    <div className="gads-subtabs" role="group" aria-label="Measurement views">{tabs.map((tab) => <button key={tab.id} aria-pressed={active.id === tab.id} onClick={() => setParams({ tab: tab.id })}>{tab.icon}{tab.label}</button>)}</div>
    <div className="gads-measurement-content">{active.render()}</div>
  </GoogleAdsShell>;
}
